<template>
  <router-link
    class="Nav__logo"
    active-class
    :to="logo.to"
    title="Website Logo"
    aria-label="Website logo"
  >
    <img :src="require(`@/assets/images/${logo.image}`)" alt="Website Logo" />
  </router-link>
</template>

<script>
export default {
  name: "Logo",
  props: {
    logo: {
      type: Object,
      required: true
    }
  }
};
</script>
